import React, { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";

import Carouselcomponent from "./carouselcomponent";
import CentralDoctraineAndOtherCommonFooterBlock from "../../../components/CentralDoctraineAndOtherCommonFooterBlock/CentralDoctraineAndOtherCommonFooterBlock";

import Main_page from "./main_page";
import Chapter_1 from "./chapter_1";
import Chapter_2 from "./chapter_2";
import Chapter_3 from "./chapter_3";
import Chapter_4 from "./chapter_4";
import Chapter_5 from "./chapter_5";
import Chapter_6 from "./chapter_6";
import Chapter_7 from "./chapter_7";
import Chapter_8 from "./chapter_8";
import Chapter_9 from "./chapter_9";
import Chapter_10 from "./chapter_10";
import Chapter_11 from "./chapter_11";
import Chapter_12 from "./chapter_12";
import Chapter_13 from "./chapter_13";
import Chapter_14 from "./chapter_14";
import Chapter_15 from "./chapter_15";
import Chapter_16 from "./chapter_16";
import Chapter_17 from "./chapter_17";
import Chapter_18 from "./chapter_18";
import Chapter_19 from "./chapter_19";
import Chapter_20 from "./chapter_20";
import Chapter_21 from "./chapter_21";
import Chapter_22 from "./chapter_22";
import Chapter_23 from "./chapter_23";
import Chapter_24 from "./chapter_24";
import Chapter_25 from "./chapter_25";
import Chapter_26 from "./chapter_26";
import Chapter_27 from "./chapter_27";
import Chapter_28 from "./chapter_28";
import Chapter_29 from "./chapter_29";
import Chapter_30 from "./chapter_30";
import Chapter_31 from "./chapter_31";
import Chapter_32 from "./chapter_32";
import Chapter_33 from "./chapter_33";
import Chapter_34 from "./chapter_34";
import Chapter_35 from "./chapter_35";
import Chapter_36 from "./chapter_36";
import Chapter_37 from "./chapter_37";
import Chapter_38 from "./chapter_38";
import Chapter_39 from "./chapter_39";
import Chapter_40 from "./chapter_40";
import Chapter_41 from "./chapter_41";
import Chapter_42 from "./chapter_42";
import Chapter_43 from "./chapter_43";
import Chapter_44 from "./chapter_44";
import Chapter_45 from "./chapter_45";
import Chapter_46 from "./chapter_46";
import Chapter_47 from "./chapter_47";
import Chapter_48 from "./chapter_48";
import Chapter_49 from "./chapter_49";
import Chapter_50 from "./chapter_50";
import Chapter_51 from "./chapter_51";
import Chapter_52 from "./chapter_52";
import Chapter_53 from "./chapter_53";
import Chapter_54 from "./chapter_54";
import Chapter_55 from "./chapter_55";
import Chapter_56 from "./chapter_56";
import Chapter_57 from "./chapter_57";
import Chapter_58 from "./chapter_58";
import Chapter_59 from "./chapter_59";
import Chapter_60 from "./chapter_60";
import Chapter_61 from "./chapter_61";
import Chapter_62 from "./chapter_62";
import Chapter_63 from "./chapter_63";
import Chapter_64 from "./chapter_64";
import Chapter_65 from "./chapter_65";
import Chapter_66 from "./chapter_66";
import Chapter_67 from "./chapter_67";
import Chapter_68 from "./chapter_68";
import Chapter_69 from "./chapter_69";
import Chapter_70 from "./chapter_70";
import Chapter_71 from "./chapter_71";
import Chapter_72 from "./chapter_72";



const slidercopenents = [
  Main_page,
  Chapter_1,
  Chapter_2,
  Chapter_3,
  Chapter_4,
  Chapter_5,
  Chapter_6,
  Chapter_7,
  Chapter_8,
  Chapter_9,
  Chapter_10,
  Chapter_11,
  Chapter_12,
  Chapter_13,
  Chapter_14,
  Chapter_15,
  Chapter_16,
  Chapter_17,
  Chapter_18,
  Chapter_19,
  Chapter_20,
  Chapter_21,
  Chapter_22,
  Chapter_23,
  Chapter_24,
  Chapter_25,
  Chapter_26,
  Chapter_27,
  Chapter_28,
  Chapter_29,
  Chapter_30,
  Chapter_31,
  Chapter_32,
  Chapter_33,
  Chapter_34,
  Chapter_35,
  Chapter_36,
  Chapter_37,
  Chapter_38,
  Chapter_39,
  Chapter_40,
  Chapter_41,
  Chapter_42,
  Chapter_43,
  Chapter_44,
  Chapter_45,
  Chapter_46,
  Chapter_47,
  Chapter_48,
  Chapter_49,
  Chapter_50,
  Chapter_51,
  Chapter_52,
  Chapter_53,
  Chapter_54,
  Chapter_55,
  Chapter_56,
  Chapter_57,
  Chapter_58,
  Chapter_59,
  Chapter_60,
  Chapter_61,
  Chapter_62,
  Chapter_63,
  Chapter_64,
  Chapter_65,
  Chapter_66,
  Chapter_67,
  Chapter_68,
  Chapter_69,
  Chapter_70,
  Chapter_71,
  Chapter_72
];

export default function Main_chapter({ allComponentViewerState }) {
  const router = useRouter();
  const isInitialLoad = useRef(true);

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (router.isReady) {
      const chapterFromUrl = parseInt(router.query.chapter, 10);
      if (
        !isNaN(chapterFromUrl) &&
        chapterFromUrl >= 0 &&
        chapterFromUrl < slidercopenents.length
      ) {
        setActiveIndex(chapterFromUrl);
      }
    }
  }, [router.isReady, router.query.chapter]);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return;
    }

    const currentChapterInUrl = parseInt(router.query.chapter, 10) || 0;

    if (activeIndex !== currentChapterInUrl) {
      router.push(
        {
          pathname: "/central-doctrine",
          query: { chapter: activeIndex },
        },
        undefined,
        { shallow: true }
      );
    }
  }, [activeIndex]);

  const nextImage = () => {
    setActiveIndex((prevIndex) =>
      Math.min(prevIndex + 1, slidercopenents.length - 1)
    );
  };

  const prevImage = () => {
    setActiveIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  return (
    <>
      <Carouselcomponent
        allComponentViewerState={allComponentViewerState}
        activeIndex={activeIndex}
        slidercopenents={slidercopenents}
        onNext={nextImage}
        onPrevious={prevImage}
        totalChapters={slidercopenents.length}
        isInitialLoad={isInitialLoad}
      />
      <CentralDoctraineAndOtherCommonFooterBlock
        allComponentViewerState={allComponentViewerState}
        onNext={nextImage}
        onPrevious={prevImage}
        currentIndex={activeIndex}
        totalChapters={slidercopenents.length}
        buttonText={"chapter"}
      />
    </>
  );
}
